import { render, staticRenderFns } from "./JVxeDateCell.vue?vue&type=template&id=a8c1fc94&scoped=true&"
import script from "./JVxeDateCell.vue?vue&type=script&lang=js&"
export * from "./JVxeDateCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c1fc94",
  null
  
)

export default component.exports